export default __webpack_public_path__ + "static/media/ic.cf95e873.jpg";